import styles from "../products/analytics-table.module.css"

export default function SupplierPerformanceTable({ suppliers }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Supplier Performance</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Orders</th>
              <th>Success Rate</th>
              <th>Revenue</th>
              <th>Profit</th>
              <th>Reliability</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            {suppliers.map((supplier, index) => (
              <tr key={index}>
                <td>{supplier._id}</td>
                <td>{supplier.totalOrders}</td>
                <td className={supplier.successRate >= 95 ? styles.success : styles.warning}>
                  {supplier.successRate}%
                </td>
                <td>₹{supplier.totalRevenue.toLocaleString()}</td>
                <td>₹{supplier.totalProfit.toLocaleString()}</td>
                <td>{supplier.reliabilityScore}</td>
                <td>
                  <span className={styles.grade}>
                    {supplier.performanceGrade} {supplier.colorIndicator}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
